export default "__VITE_ASSET__251125b8__"